import { JDSFooterLinksGridProps } from './generated/interface';

export const withLogic =
  (
    Component: React.ComponentType<JDSFooterLinksGridProps>
  ): React.FC<JDSFooterLinksGridProps> =>
  (props: JDSFooterLinksGridProps) => {
    return <Component {...props} />;
  };
